// ─── Auth ────────────────────────────────────────────────────────────────────
export const USER_ID = 'USER_ID';
export const USER_LOADING = 'USER_LOADING';
export const GET_USERS_ALL = 'GET_USERS_ALL';
export const AUTH_ERROR = 'AUTH_ERROR';
export const USER_DETAIL = 'USER_DETAIL';
export const LOGOUT = 'LOGOUT';

// ─── Citas ───────────────────────────────────────────────────────────────────
export const CREATE_CITA_REQUEST = 'CREATE_CITA_REQUEST';
export const CREATE_CITA_SUCCESS = 'CREATE_CITA_SUCCESS';
export const CREATE_CITA_FAILURE = 'CREATE_CITA_FAILURE';

// ─── Proyectos ────────────────────────────────────────────────────────────────
export const CREATE_PROYECTS = 'CREATE_PROYECTS';
export const GET_PROYECTS = 'GET_PROYECTS';
export const UPDAT_EPROYECTS = 'UPDAT_EPROYECTS';
export const DELETE_PROYECTS = 'DELETE_PROYECTS';

// ─── Reviews ─────────────────────────────────────────────────────────────────
export const REVIEWS_REQUEST = 'REVIEWS_REQUEST';
export const REVIEWS_SUCCESS = 'REVIEWS_SUCCESS';
export const REVIEWS_FAILURE = 'REVIEWS_FAILURE';

// ─── AI / Groq ───────────────────────────────────────────────────────────────
export const AI_CHAT_REQUEST = 'AI_CHAT_REQUEST';
export const AI_CHAT_SUCCESS = 'AI_CHAT_SUCCESS';
export const AI_CHAT_FAILURE = 'AI_CHAT_FAILURE';
export const AI_PRESUPUESTO_REQUEST = 'AI_PRESUPUESTO_REQUEST';
export const AI_PRESUPUESTO_SUCCESS = 'AI_PRESUPUESTO_SUCCESS';
export const AI_PRESUPUESTO_FAILURE = 'AI_PRESUPUESTO_FAILURE';
export const AI_CLEAR_SESSION = 'AI_CLEAR_SESSION';
